import { Navigate } from "react-router";
import { selectAuth, useAppSelector } from "../../store";
import { hasPrivilege } from "../../../redux/utils/authPrivileges";

/**
 * Restricts child routes to users with a JWT privilege claim.
 */
export function PrivilegeRoute({ privilege, children }) {
  const decodedToken = useAppSelector(selectAuth).decodedToken;
  const allowed = hasPrivilege(decodedToken, privilege);

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
